<template>
  <div class="container-fluid py-3 px-4">

    <!-- TITULO -->
    <div class="border border-1 rounded-3 p-3 mb-3 ">
      <div class="d-flex align-items-center gap-3 mb-2 mx-2 flex-wrap">
        <i class="bi bi-geo-alt-fill display-4 text-primary"></i>
        <div>
          <p class="mb-0 reducirTamaño text-secondary fw-semibold text-uppercase">
            RUTAS
          </p>
          <p class="mb-0 tituloResaltado fs-4 fw-bold">
            MANTENIMIENTO
          </p>
        </div>
      </div>
    </div>

    <!-- SECCIÓN DIVIDIDA A LA IZQUIERDA Y DERECHA -->
    <div class="row gx-3">

      <!-- ========================================= -->
      <!--     COLUMNA IZQUIERDA (FORMULARIO + BUSCADOR) -->
      <!-- ========================================= -->
      <div class="col-12 col-lg-5">

        <!-- FORMULARIO -->
        <div class="border border-1 rounded-3 p-3 mb-3">
          <form class="mt-2" @submit.prevent="GrabarEntrevista">
            <div class="row gy-3">

              <!-- (tu FORMULARIO va aquí SIN CAMBIOS) -->
              <!-- ------------------------------------- -->

              <!-- PUNTO DE VENTA -->
              <div class="col-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-shop text-primary fs-6"></i>
                  PUNTO DE VENTA:
                </label>
                <multiselect class="tamaño quitar" v-model="codigoTienda" :options="listado"
                  :custom-label="nameWithLang" track-by="tieNombre" label="tieNombre"
                  placeholder="--SELECCIONAR EL PUNTO DE VENTA--">
                  <template #singleLabel="{ option }">
                    <strong>{{ option.tieNombre }}</strong>
                  </template>
                </multiselect>
              </div>

              <!-- TRABAJADOR -->
              <div class="col-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-person-badge text-success fs-6"></i>
                  LISTA DE TRABAJADORES:
                </label>
                <multiselect class="tamaño quitar" v-model="value" track-by="nombreTrabajador" label="nombreTrabajador"
                  placeholder="--SELECCIONAR TRABAJADOR--" :custom-label="FiltroTrabajador"
                  :options="listadoTrabajador">
                  <template #singleLabel="{ option }">
                    <strong>{{ option.nombreTrabajador }}</strong>
                  </template>
                </multiselect>
              </div>

              <!-- HORARIO -->
              <div class="col-12">
                <label class="tamaño d-flex align-items-center gap-2">
                  <i class="bi bi-clock-fill text-warning fs-6"></i>
                  HORARIO DE TRABAJO:
                </label>
                <select required class="form-control py-2 text-secondary tamaños"
                  @change="Horario = $event.target.value">
                  <option disabled selected value="">--SELECCIONAR HORARIO--</option>
                  <option v-for="horario in informacion" :key="horario.id" :value="horario.idHorario">
                    {{ horario.fecDescripcion }}
                  </option>
                </select>
              </div>

              <!-- VOLANTE -->
              <div class="col-12 d-flex align-items-center pt-2">
                <input type="checkbox" v-model="valor" />
                <label class="ms-2 tamaños d-flex align-items-center gap-2">
                  <i class="bi bi-send-check-fill text-info fs-6"></i>
                  Volante
                </label>
              </div>

              <!-- GUARDAR -->
              <div class="col-12 d-flex justify-content-center">
                <button class="btn btn-success px-4 py-2">
                  <i class="bi bi-folder-check fs-5"></i>
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>

      <!-- BUSCADOR -->
      <!-- COLUMNA DERECHA COMPLETA (BUSCADOR + TABLA) -->
      <div class="col-12 col-lg-7 ms-auto"> <!-- ms-auto = empuja todo a la derecha -->
        <!-- BUSCADOR -->
        <div class="border border-1 rounded-3 p-3 mb-4">
          <div class="d-flex justify-content-end align-items-center gap-2">
            <label class="mt-2 tamaños d-flex align-items-center gap-2 mb-2">
              <i class="bi bi-search text-primary fs-6"></i> BUSCAR:
            </label>
            <input class="form-control form-control-lg w-50 mt-1 tamaños mb-2" type="text"
              placeholder="TIPO DE ENTREVISTA.." v-model="tipoRuta" @input="Buscador" />
          </div>

          <!-- TABLA -->


          <div class="table-responsive">
            <table class="table table-bordered">
              <thead>
                <tr class="bg-solimano-table text-white text-center tamaño2 text-nowrap">
                  <th>ID</th>
                  <th>VOLANTE</th>
                  <th>NOMBRE TRABAJADOR</th>
                  <th>HORARIO</th>
                  <th>TIENDA</th>
                  <th>ACCIÓN</th>
                </tr>
              </thead>

              <tbody>
                <!-- Spinner mientras se cargan los datos -->
                <tr v-if="loading">
                  <td colspan="6" class="text-center py-5">
                    <div class="spinner-border text-primary" role="status" style="width: 3rem; height: 3rem;">
                      <span class="visually-hidden">Cargando...</span>
                    </div>
                  </td>
                </tr>
                <tr v-else v-for="post in rutasPaginadas" :key="post.idRuta"
                  class="tamaños text-nowrap align-middle">

                  <!-- ID -->
                  <td class="fw-bold text-center">
                    <i class="bi bi-hash text-primary fs-6 "></i>
                    {{ post.idRuta }}
                  </td>

                  <!-- VOLANTE -->
                  <td class="text-center">
                    <i v-if="post.indVolante" @click="ParamsVolante(post, post.idTrabajador)" v-b-modal.modal-center1
                      class="bi bi-send-check-fill  text-warning fs-6"></i>
                  </td>

                  <!-- TRABAJADOR -->
                  <td class="text-center">
                    <i class="bi bi-person-fill text-info fs-6 me-2"></i>
                    {{ post.nomTrabajador }}
                  </td>

                  <!-- HORARIO -->
                  <td class="text-center">
                    <i class="bi bi-clock-history text-success  fs-6 me-2"></i>
                    {{ post.horario }}
                  </td>

                  <!-- TIENDA -->
                  <td class="text-center">
                    <i class="bi bi-shop text-primary fs-6 me-2"></i>
                    {{ post.tieNombre }}
                  </td>

                  <!-- ACCIONES -->
                  <td class="text-center">
                    <button v-b-modal.modal-center @click="paramsRutaId(post.idRuta)"
                      class="btn btn-success text-white me-2">
                      <i class="bi bi-pencil-square"></i>
                    </button>
                    <button class="btn btn-danger" @click="EliminarRuta(post.idRuta)">
                      <i class="bi bi-trash3"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>

            <!-- PAGINACIÓN -->
          </div>
          <!-- PAGINACIÓN NUEVA -->
          <div class="pagination-container d-flex justify-content-center align-items-center gap-2 my-3">

            <!-- Ir a primera página -->
            <button class="btn btn-outline-primary btn-sm" @click="currentPage = 1" :disabled="currentPage === 1">
              <i class="bi bi-chevron-double-left"></i>
            </button>

            <!-- Retroceder -->
            <button class="btn btn-outline-primary btn-sm" @click="currentPage--" :disabled="currentPage === 1">
              <i class="bi bi-chevron-left"></i>
            </button>

            <!-- Info de página -->
            <span class="pagination-info fw-bold">
              Página {{ currentPage }} de {{ totalPages }}
            </span>

            <!-- Avanzar -->
            <button class="btn btn-outline-primary btn-sm" @click="currentPage++"
              :disabled="currentPage === totalPages">
              <i class="bi bi-chevron-right"></i>
            </button>

            <!-- Última página -->
            <button class="btn btn-outline-primary btn-sm" @click="currentPage = totalPages"
              :disabled="currentPage === totalPages">
              <i class="bi bi-chevron-double-right"></i>
            </button>

          </div>

        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Multiselect from "vue-multiselect";
import Swal from "sweetalert2";
import "vue-multiselect/dist/vue-multiselect.min.css";

export default {
  name: "SolimanoLogRuta",
  components: {
    Multiselect,
  },

  data() {
    return {
      loading: false,
      currentPage: 1,
      itemsPerPage: 4,
      filterField: "",

      listado: [],
      listadoTrabajador: [],
      rutas: [],
      informacion: [],

      ubicacionActual: null,
      watchId: null,
      value: null,
      listadoTienda: "",
      Horario: "",

      codigoTienda: "",
      codigoTrabajador: "",
      idTrabajador: "",
      valor: false,
      fecha: "",

      editarCodigoTienda: [],
      editarValue: "",
      editarHorario: "",
      idRuta: "",

      nombrePuestoVenta: "",
      nombreTrabajador: "",
      horariosEstablecido: "",
      valorPredeterminadoIdTienda: "",
      valorPredeterminadoIdTrabajador: "",
      valorVolanteEstablecido: Boolean,

      parametroIdVolante: [],
      fechas: "",
      codigoTiendaInsertar: "",
      HorarioMod: "",
      idTrabajadorVolante: "",
      nombreDelTrabajador: "",
      tipoRuta: ""
    };
  },
  computed: {
    
      rutasFiltradas() {
        return this.rutas; // si luego agregas buscador, aquí va
      },

      rutasPaginadas() {
        const start = (this.currentPage - 1) * this.itemsPerPage;
        return this.rutasFiltradas.slice(start, start + this.itemsPerPage);
      },

      totalPages() {
        return Math.ceil(this.rutasFiltradas.length / this.itemsPerPage);
      }

  },

  async mounted() {
    let depa = await this.axios.get("ParametroData/Parametro/350");
    this.departamento = depa.data;
  },
  created() {
    this.cambiarEstadoNavbar();
    this.getListado();
    this.listadoTrabajadores();
    this.getAttributes();
    this.getListadoRutas();
  },

  methods: {

    Buscador() {

      this.loading = true;
      this.rutas = [];
      if (this.tipoRuta.trim().length === 0) {
        this.getListadoRutas()
          .finally(() => {
            setTimeout(() => {
              this.loading = false;
            }, 800);
          });
        return;
      }
      this.axios.get(
        `Asistencia/BusquedaRuta?idTrabajador=${localStorage.getItem("idTrabajdor")}&busqueda=${this.tipoRuta}`
      )
        .then((r) => {
          // console.log('informacion',r.data)
          this.rutas = r.data;
        })
        .catch(() => {
          this.rutas = [];
        })
        .finally(() => {
          setTimeout(() => {
            this.loading = false;
          }, 800);
        });
    },

    nameWithLang({ tieNombre }) {
      return `${tieNombre}`;
    },

    FiltroTrabajador({ nombreTrabajador }) {
      return `${nombreTrabajador}`;
    },

    ParamsVolante(items, idTrabajador) {
      console.log(items.idTrabajador);
      this.idTrabajadorVolante = items.idTrabajador
      this.nombreDelTrabajador = items.nomTrabajador;
      this.axios
        .get(`Asistencia/ListarVolantexid?idTrabajador=${idTrabajador}`)
        .then((r) => {
          console.log(r.data);
          this.parametroIdVolante = r.data;
        });
    },

    paramsRutaId(id) {
      this.idRuta = id;
      console.log(id);
      this.axios.get(`Asistencia/ListarRutaxid?idRuta=${id}`).then((r) => {
        console.log(r.data);

        this.nombrePuestoVenta = r.data[0].tieNombre;
        this.nombreTrabajador = r.data[0].nomTrabajador;
        this.horariosEstablecido = r.data[0].horario;
        this.valorVolanteEstablecido = r.data[0].indVolante;
        this.valorPredeterminadoIdTrabajador = r.data[0].idTrabajador;
        this.valorPredeterminadoIdTienda = r.data[0].idTienda;
        this.editarHorario = r.data[0].idHorario;
      });
    },

    ModificarRutas() {
      const from = {
        idTienda:
          this.editarCodigoTienda.idTienda ?? this.valorPredeterminadoIdTienda,
        idHorario: this.editarHorario,
        idTrabajador:
          this.editarValue.idTrabajador ?? this.valorPredeterminadoIdTrabajador,
        idRuta: this.idRuta,
        indVolante: this.valorVolanteEstablecido,
      };
      console.log(from);
      this.axios.put(`Asistencia/ModificarRuta`, from).then((r) => {
        console.log(r.data);
        if (r.data) {
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Se realizó cambios",
            showConfirmButton: false,
            timer: 1500,
          });
        }
        this.getListadoRutas();
      });
    },
    getAttributes() {
      this.axios.get(`Asistencia/ListadoHorario`).then((r) => {
        console.log(r.data);
        this.informacion = r.data;
      });
    },
    GrabarEntrevista() {
      console.log("no funciono perro");
      const from = {
        idTienda: this.codigoTienda.idTienda,
        idHorario: this.Horario,
        idTrabajador: this.value.idTrabajador,
        indVolante: this.valor,

      };
      // fecVolante: this.fecha,
      console.log(from);
      this.axios
        .post(`Asistencia/RegistrarRuta`, from)
        .then((r) => {
          console.log(r.data);

          if (r.data) {
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se registró cambios",
              showConfirmButton: false,
              timer: 1500,
            });
          }
          this.getListadoRutas();
        })
        .catch((error) => {
          console.log(error);
          Swal.fire({
            icon: "error",
            title: `${error.response.data}`,
            text: "",
            footer: "",
          });
        });
    },

    guardar() {

      console.log(this.parametroIdVolante);

      const from = {
        idTienda: this.codigoTiendaInsertar.idTienda,
        idHorario: this.HorarioMod,
        idTrabajador: this.idTrabajadorVolante,
        fecVolante: this.fechas,
      };
      this.axios
        .post(`Asistencia/RegistrarVolante`, from)
        .then((r) => {
          console.log(r.data);
          if (r.data) {
            this.ParamsVolante(this.parametroIdVolante[0], this.idTrabajadorVolante);
            Swal.fire({
              position: "center",
              icon: "success",
              title: "Se registró cambios",
              showConfirmButton: false,
              timer: 1500,
            });
          }

        })
        .catch((error) => {
          console.log(error)
          Swal.fire({
            icon: "error",
            title: `${error.response.data}`,
            text: "",
            footer: '',
          });
        });
    },
    EliminarAsistencia(items) {
      console.log(items.idVolante);

      Swal.fire({
        title: "¿ELIMINAR HORARIO SELECCIONADO?",
        text: "",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "SI",
        cancelButtonText: "NO",
      }).then((result) => {
        if (result.isConfirmed) {
          Swal.fire({
            title: "¡Eliminado con Éxito!",
            text: "",
            icon: "success",
          });
          this.axios
            .delete(`Asistencia/EliminarVolante?idVolante=${items.idVolante}`)
            .then((r) => {
              console.log(r.data);
            });

          this.ParamsVolante(this.parametroIdVolante[0],
            this.idTrabajadorVolante);
        }
      });
    },
    listadoTrabajadores() {
      this.idTrabajador = localStorage.getItem(`idTrabajdor`);

      this.axios
        .get(`Asistencia/ListarTrabajador?idTrabajador=${this.idTrabajador}`)
        .then((r) => {
          console.log(r.data);
          this.listadoTrabajador = r.data;
        });
    },

    getListado() {
      this.axios.get(`Asistencia/ListarPuntoVenta`).then((r) => {
        console.log(r.data);
        this.listado = r.data;
      });
    },

   getListadoRutas() {
  return this.axios
    .get(
      `Asistencia/ListarRuta?idTrabajador=${localStorage.getItem(
        "idTrabajdor"
      )}`
    )
    .then((r) => {
      this.rutas = r.data;
    });
},


    cambiarEstadoNavbar() {
      // Acción directa para cambiar el estado del navbar a true
      this.$store.dispatch("acciones/CambioNavbar", true);
    },

        EliminarRuta(id) {
        // 1. Confirmación antes de eliminar (recomendado)
        Swal.fire({
          title: '¿Estás seguro?',
          text: "Esta acción no se puede deshacer",
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: 'Sí, eliminar',
          cancelButtonText: 'Cancelar'
        }).then((result) => {
          if (result.isConfirmed) {
            
            // 2. Llamada a la API usando el ID en la ruta
            // Nota: Asegúrate que el prefijo coincida con tu Controller (Asistencia o Contrato)
            this.axios.delete(`Asistencia/EliminarRuta/${id}`)
              .then((response) => {
                if (response.data === true) {
                  Swal.fire(
                    '¡Eliminado!',
                    'La ruta ha sido eliminada correctamente.',
                    'success'
                  );
                  // 3. Refrescar la lista después de eliminar
                  this.getListadoRutas(); 
                }
              })
              .catch((error) => {
                console.error(error);
                Swal.fire(
                  'Error',
                  'No se pudo eliminar la ruta: ' + error.message,
                  'error'
                );
              });
          }
        });
      }

  },
};
</script>

<style scoped>
.tituloResaltado {
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}
.reducirTamaño {
  font-size: 0.65rem;
}
.tamaño {
  font-size: 0.65rem;

  font-weight: 800;
  color: #002c5d;
}

.tamaños {
  font-size: 0.65rem;
}

.tamaño2 {
  font-size: 0.65rem;
  font-weight: 800;
}

.titulo {
  color: #0080c8;
  text-decoration: underline;
}

.bg-solimano {
  border-color: #0080c8;
  border-width: 2px;
}

.bg-solimano-table {
  background: #0080c8;
}

.btn-solimano {
  background: #0080c8;
}

.tituloColorMas {
  /* color: #002c5d; */
  font-weight: 500;
  text-decoration: none;
  font-size: 1.23rem;
}

.quitar {
  font-weight: 500;
}

.medida {
  width: 420px;
  height: 44px;
  border-color: #e9e9e9;
}

.medidaFecha {
  width: 160px;
  height: 44px;
  border-color: #e9e9e9;
}
</style>